import React from 'react';
import Slide from '@mui/material/Slide';
import type { TransitionProps } from '@mui/material/transitions';

const Transition = React.forwardRef((
  props: TransitionProps & { children: React.ReactElement },
  ref: React.Ref<unknown>,
) => <Slide direction='up' ref={ref} {...props} />);

export default Transition;
